module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"copy-success":"Le lien a été copié dans votre presse-papier.","copy-failure":"Oups! Le lien n\u0027a pas pu être copié."},"en":{"copy-success":"The link has been copied into your clipboard.","copy-failure":"Oops! The link couldn\u0027t be copied."}}')
  delete Component.options._Ctor
}
